module.exports = __webpack_public_path__ + "img/51600.9f3d61ba.jpg";